export const SUCCESS_NOTIFICATION_EXCLUDED_URLS = [
  "/ecommerce/internal/notification/fcm/token",
];

const getPath = (url = "") => {
  try {
    return new URL(url, window.location.origin).pathname;
  } catch {
    return url.split("?")[0];
  }
};

export const shouldSkipSuccessNotification = (config = {}) => {
  if (config.skipSuccessNotification) return true;

  const basePath = getPath(config.baseURL).replace(/\/$/, "");
  const requestPath = getPath(config.url);
  const fullRequestPath = `${basePath}${requestPath}`;

  return SUCCESS_NOTIFICATION_EXCLUDED_URLS.some(
    (endpoint) => endpoint === requestPath || endpoint === fullRequestPath,
  );
};

export const shouldShowSuccessNotification = (response) => {
  const config = response?.config || {};
  const method = config.method?.toLowerCase();
  const isMutation = ["post", "put", "delete", "patch"].includes(method);
  const isAuthPage = window.location.pathname.split("/").includes("auth");

  return (
    response?.data?.success &&
    isMutation &&
    !isAuthPage &&
    !shouldSkipSuccessNotification(config)
  );
};
